module.exports = __webpack_public_path__ + "static/media/link_icon_gray.3d04ccb5.svg";